import { ArrowLeft, ScanSearch } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ValidationHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 mb-6">
      <button
        onClick={() => navigate('/selection')}
        className="p-2 rounded-lg hover:bg-teal-100 transition-colors"
      >
        <ArrowLeft className="w-6 h-6 text-teal-700" />
      </button>
      <div className="flex items-center gap-3">
        <ScanSearch className="w-8 h-8 text-teal-600" />
        <h1 className="text-2xl font-bold text-teal-800">
          Validacao de Codigo de Barras
        </h1>
      </div>
    </div>
  );
}
